export default {
  userId: localStorage.getItem('algerieDok-U') || null,
  user: null,
  cloudinaryUrl: "https://res.cloudinary.com/dba2dcapc/image/upload/v1611178444/",
  token: localStorage.getItem('algerieDok-T') || null,
  locale:localStorage.getItem('lang') || 'fr'
}
